import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import DatePicker from '../../../../components/ui/DatePicker/DatePicker'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import Dropdown from '../../../../components/ui/Dropdown/Dropdown'

import getGenders from '../../../../services/data/getGenders'

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`

const StyledButton = styled(ActionButton)`
  width: 100%;
`

const StyledDatePicker = styled(DatePicker).attrs({
  withIcon: true,
  variant: 'small',
})`
  .react-datepicker-wrapper {
    span {
      font-size: 0.8rem !important;
      color: var(--color-fg);
    }
  }
  font-size: 0.8rem;
`

const StyledDropdown = styled(Dropdown).attrs({
  iconColor: 'var(--color-primary)',
  variant: 'small',
})`
  select {
    font-size: 0.8rem;
  }
`

const StyledFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`

function UpdateProfilePageForm(props) {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
    initialValues = {},
    setFieldValue,
  } = props

  const GENDERS = getGenders()

  React.useEffect(() => {
    const { birthdate, gender } = initialValues
    if (birthdate) setFieldValue('birthdate', undefined)
    if (gender !== null) setFieldValue('gender', undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues])

  // const isEnabled =
  //   (!!initialValues.birthdate && !!values.birthdate) ||
  //   (!!initialValues.gender && !!values.gender)

  return (
    <>
      <form
        onSubmit={handleSubmit}
        method={method}
        action={action}
        autoComplete="off"
        style={{
          height: '100%',
        }}
      >
        <StyledFieldset disabled={isSubmitting || disabled}>
          <div
            style={{
              display: 'flex',
              flex: 1,
            }}
          >
            {!initialValues.birthdate && (
              <>
                <div
                  style={{
                    width: 0,
                    flex: 'auto',
                  }}
                >
                  <StyledDatePicker
                    name="birthdate"
                    type="text"
                    placeholder="Date of Birth"
                    data-testid="registerBirthdate"
                    maskInput={false}
                    dateFormat="MMMM yyyy"
                    dateValueFormat="YYYY-MM"
                    showMonthYearPicker
                    initialValue={values.birthdate}
                    error={errors.birthdate}
                    touched={touched.birthdate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    max={values.yesterday}
                    withIcon
                  />
                </div>
              </>
            )}
            {!initialValues.birthdate && initialValues.gender === null && (
              <div
                style={{
                  width: '1rem',
                }}
              />
            )}

            {initialValues.gender === null && (
              <div
                style={{
                  width: 0,
                  flex: 'auto',
                }}
              >
                <StyledDropdown
                  name="gender"
                  placeholder="Gender"
                  data-testid="registerGender"
                  initialValue={
                    initialValues.gender ? values.gender : undefined
                  }
                  error={errors.gender}
                  touched={touched.gender}
                  options={GENDERS}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
            )}
          </div>
          <ButtonWrapper>
            <StyledButton
              type="submit"
              variant="primary"
              // disabled={!isValid && !isEnabled}
              disabled={!isValid}
            >
              Save
            </StyledButton>
          </ButtonWrapper>
        </StyledFieldset>
      </form>
    </>
  )
}

UpdateProfilePageForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

UpdateProfilePageForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
}

export default UpdateProfilePageForm
